<template>
  <div class="my-0 text-center">
    <p class="p-2 secondary-back" v-if="statusMsg">{{ statusMsg }}</p>
    <h1 class="text-4xl">Update Account</h1>
    <!-- <p class="max-w-sm mx-auto">Update your account.</p> -->
    <div class="mt-4">Your full name</div>
    <input class="ctrl w-96 border-b" v-model="name" placeholder="First Last" />
    <div class="mt-4">Your email</div>
    <input class="ctrl w-96 border-b" v-model="email" placeholder="name@domain.com" />
    <button class="ctrl btn mt-4" v-on:click="editAcct">{{ createBtnTxt }}</button>
  </div>
</template>

<style scoped>
.ctrl {
  @apply block mx-auto mt-2;
}
.btn {
  @apply bg-primaryColor text-white p-4;
}
hover:.btn {
  @apply underline;
}
.secondary-back {
  background-color: #c9d99e;
}
</style>

<script>
import utils from '@/services/utils';
import userInfo from '@/services/userInfo';
// import twitterAuth from '@/services/twitterAuth';
import store from '@/store';

export default {
  name: 'edit',
  store,
  data() {
    return {
      statusMsg: '',
      createBtnTxt: 'Update Account',
      name: '',
      email: '',
    };
  },
  computed: {
    user() {
      return store.state.user;
    },
  },
  async mounted() {
    if (this.user) {
      const ui = await userInfo.getUserInfo(this.user.uid);

      this.name = ui.userName;
      this.email = ui.userEmail;
    }
  },
  methods: {
    async editAcct() {
      utils.log('applying editAcct ');
      this.createBtnTxt = 'Please Wait...';
      await userInfo.setAcctInfo(this.name, this.email);
      // twitterAuth.setEmailNeedsVerification();
      utils.setStatusMsg(this, 'Account Updated. Please check your e-mail and confirm your address.');
      this.$router.push('/home');
    },
  },
};
</script>
